import accidents from './accidents';
import { MaintenanceReport } from "../CRUDs/entities/MaintenanceReport";

export default {
    dropzoneFiles: {},
    init() {
        accidents.sort_date('maintenance-report__table-box-img', 'maintenance_reports');
        this.initNewDropZone();
        this.listeners();
    },

    listeners(){
        $('body').off('click', '.data-view.maintenance-reports .data-row .edit')
                .on('click', '.data-view.maintenance-reports .data-row .edit', ev=>{
            new MaintenanceReport($(ev.currentTarget).data('maintenance_id')).openModal('edit', {}, false);
        })
    },

    initNewDropZone(){
        if(window.location.pathname.startsWith('/vehicles-management')){
            this.id = '';
            this.urlRoot = '/vehicles-mangement/';
            this.vehicle =  new MaintenanceReport('', '/vehicles-management/vehicleMaintenanceReport', 'maintenance-report');
        }
    }
}
